module.exports = __webpack_public_path__ + "c0b4f4ddbbe54aa8cdaf2679cf33b7b7.svg";